// extracted by mini-css-extract-plugin
export default {"pricingPlanChosenLine":"S0JFhcN34ZYS3jQoNbWr","pricingPlanChosenLineText":"zRPseuvvCUI_6c_4dL9b"};